<template>
    <!-- 验证码组件 -->
    <!-- 是否主动验证： isInitiativeCheck -->
    <!-- 主动验证回调：@checkVerification -->
    <!-- 校验函数：checkVerification  （this.$refs.xxx.checkVerification）-->
    <!-- 校验长度：defaultSize -->
    <!-- 是否禁用：disabled -->
    <!-- 输入框宽高：inputW、inputH -->
    <!-- 验证码宽高：canvasW、canvasW -->
    <!-- 验证码字体：fontSizeMin、fontSizeMax -->

    <div class="check_code">
        <el-input
            ref="checkCodeInput"
            v-model="inputVerification"
            @blur="_blur"
            @focus="_focus"
            @clear="_clear"
            :change="_change(inputVerification)"
            :disabled="disabled"
            :maxlength="defaultSize"
            placeholder="请输入验证码"
            :style="inputStyle"
            class="check_code_input"
            show-word-limit
            clearable
        ></el-input>
        <div class="s-canvas" @click="_replaceVerification">
            <canvas id="s-canvas" :width="canvasW" :height="canvasH"></canvas>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tdVerificationCode',
    props: {
        // 输入框显示数据
        value: {
            type: [String, Number]
        },
        //是否主动校验
        isInitiativeCheck: {
            type: Boolean,
            default: true
        },
        //校验长度
        defaultSize: {
            type: Number,
            default: 4
        },
        //输入框是否禁用
        disabled: {
            type: Boolean,
            default: false
        },
        //输入框宽
        inputW: {
            Number,
            default: 200
        },
        //验证码宽
        canvasW: {
            type: Number,
            default: 112
        },
        //验证码高
        canvasH: {
            type: Number,
            default: 38
        },
        //验证码最小字体
        fontSizeMin: {
            type: Number,
            default: 16
        },
        //验证码最大字体
        fontSizeMax: {
            type: Number,
            default: 40
        }
    },
    watch: {
        value(newVal) {
            this.inputVerification = newVal;
        },
        defaultVerification() {
            this.drawPic();
        }
    },
    data() {
        return {
            //输入的验证码
            inputVerification: '',
            //默认验证码
            defaultVerification: '',
            //验证结果
            checkResult: false,
            inputStyle: {
                width: this.inputW + 'px'
            },
            backgroundColorMin: 180,
            backgroundColorMax: 240,
            colorMin: 50,
            colorMax: 160,
            lineColorMin: 40,
            lineColorMax: 180,
            dotColorMin: 0,
            dotColorMax: 255
        };
    },
    created() {},
    mounted() {
        //初始化验证码
        this._replaceVerification();
    },
    methods: {
        _change(value) {
            let newValue = '';
            if (this.specialCharacterCheck && !this.$util.isEmpty(value) && typeof value == 'string') {
                let pattern = new RegExp("[`~!$^&*()=|{}';'\\[\\]<>?~！@#￥……&*（）——|{}【】‘；：’‘”“'。，、？]");
                for (let i = 0; i < value.length; i++) {
                    newValue = newValue + value.substr(i, 1).replace(pattern, '');
                }
                this.inputVerification = newValue;
            } else {
                newValue = value;
            }
            // 实现数据向父组件的的实时传输
            this.$emit('input', newValue);
            /* 在值改变时触发,父组件可进行注册change方法 */
            this.$emit('change', newValue);
        },
        _clear(e) {
            this.$emit('clear', e);
        },
        _focus(e) {
            this.$emit('focus', e);
        },
        //输入框失去焦点触发
        _blur(e) {
            if (this.isInitiativeCheck) {
                //抛出校验结果
                this.$emit('checkVerification', this.checkVerification());
            }
            this.$emit('blur', e);
        },
        /* 使 input 获取焦点 */
        focus() {
            this.$refs.checkCodeInput.focus();
        },
        /* 使 input 失去焦点 */
        blur() {
            this.$refs.checkCodeInput.blur();
        },
        //校验验证码
        checkVerification() {
            this.checkResult = this.inputVerification == this.defaultVerification;
            this._replaceVerification();
            return this.checkResult;
        },
        //更换验证码
        _replaceVerification() {
            let verificationCode = '';
            for (let i = 0; i < this.defaultSize; i++) {
                verificationCode += this.randomNum(1, 10);
            }
            this.defaultVerification = verificationCode;
        },
        // 生成一个随机数
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        // 生成一个随机的颜色
        randomColor(min, max) {
            var r = this.randomNum(min, max);
            var g = this.randomNum(min, max);
            var b = this.randomNum(min, max);
            return 'rgb(' + r + ',' + g + ',' + b + ')';
        },
        //绘制验证码图片
        drawPic() {
            var canvas = document.getElementById('s-canvas');
            var ctx = canvas.getContext('2d');
            ctx.textBaseline = 'bottom';
            // 绘制背景
            ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax);
            ctx.fillRect(0, 0, this.canvasW, this.canvasH);
            // 绘制文字
            for (let i = 0; i < this.defaultVerification.length; i++) {
                this.drawText(ctx, this.defaultVerification[i], i);
            }
            this.drawLine(ctx);
            this.drawDot(ctx);
        },
        // 绘制文字
        drawText(ctx, txt, i) {
            ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
            // ctx.font = 'normal bold ' + this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei';
            ctx.font = 'normal bold ' + this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px Verdana';
            var x = (i + 1) * (this.canvasW / (this.defaultVerification.length + 1));
            var y = this.randomNum(this.fontSizeMax, this.canvasH - 5);
            var deg = this.randomNum(-45, 45);
            // 修改坐标原点和旋转角度
            ctx.translate(x, y);
            ctx.rotate((deg * Math.PI) / 180);
            ctx.fillText(txt, 0, 0);
            // 恢复坐标原点和旋转角度
            ctx.rotate((-deg * Math.PI) / 180);
            ctx.translate(-x, -y);
        },
        // 绘制干扰线
        drawLine(ctx) {
            for (let i = 0; i < 8; i++) {
                ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax);
                ctx.beginPath();
                ctx.moveTo(this.randomNum(0, this.canvasW), this.randomNum(0, this.canvasH));
                ctx.lineTo(this.randomNum(0, this.canvasW), this.randomNum(0, this.canvasH));
                ctx.stroke();
            }
        },
        // 绘制干扰点
        drawDot(ctx) {
            for (let i = 0; i < 100; i++) {
                ctx.fillStyle = this.randomColor(0, 255);
                ctx.beginPath();
                ctx.arc(this.randomNum(0, this.canvasW), this.randomNum(0, this.canvasH), 1, 0, 2 * Math.PI);
                ctx.fill();
            }
        }
        //
    }
};
</script>
<style>
.check_code .check_code_input {
    float: left;
    margin-right: 10px;
}
.check_code .s-canvas {
    float: left;
    padding-top: 1px;
    padding-bottom: 1px;
    cursor: pointer;
}
</style>
